import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import SmartBanner from 'react-smartbanner';
import { StyledContentDiv } from './MobileSmartBanner.styles';
import 'react-smartbanner/dist/main.css';
import './MobileSmartBanner.css';

export interface MobileSmartBannerProps {}

const MobileSmartBanner: FC<MobileSmartBannerProps> = () => {
  const { t } = useTranslation('MobileSmartBanner');

  return (
    <StyledContentDiv id="MobileSmartBanner">
      <SmartBanner
        daysHidden={30}
        daysReminder={1}
        appStoreLanguage="us"
        title={t('title')}
        author={t('author')}
        button={t('buttonLabel')}
        storeText={{
          ios: '',
          android: '',
        }}
        price={{
          ios: '',
          android: '',
        }}
        position="top"
        // force="ios"
        url={{
          ios: 'https://apps.apple.com/app/apple-store/id1549342167?pt=1948947&ct=gcx-clientsinvca-login-sticky&mt=8',
          android: 'https://investia.ca/mobile-app-store-redirect',
        }}
        ignoreIosVersion={false}
      />
    </StyledContentDiv>
  );
};

export default MobileSmartBanner;
